import React from 'react';

import {useSelector} from 'react-redux';
import {documentService} from "../../../store/services";
import {SECURITY_ROLES} from "../../../constants/SECURITY_ROLES";
import FileListWindow from "../components/FileListWindow";
import moment from "moment";
import {documentActions} from "../../../store/actions";
import {DOCUMENT_VIEWER_MODES} from "../../../constants/DOCUMENT_VIEWER_MODES";

const ListDocument = (props) => {
  const {
    location
  } = props;

  const {role, id} = useSelector(state => state.authentication.user);

  const isSharedUserVarSet = location.isSharedUser;
  const isSharedUserRole = role === SECURITY_ROLES.SHARED_USER;
  const sharedUser = isSharedUserRole || isSharedUserVarSet;

  const title = sharedUser ?
    ((location.documentsByMember) ? 'Multimedia in Virtual Data Room' : 'Multimedia in Virtual Data Rooms') :
    'Multimedia';

  const subtitle  = isSharedUserVarSet ?
    `Available VDRs shared with ${(location.sharedUserName).toUpperCase()}` :
    isSharedUserRole ?
      ((location.documentsByMember) ? 'Available multimedia shared by ' + location.memberName : 'Available multimedia in VDRs') :
      'Available multimedia';

  const getMethod = isSharedUserRole ?
    id => documentService.getDocumentForSharedUserById(id) :
    id => documentService.getDocumentById(id);

  const sharedUserGuid = sharedUser ?
    (isSharedUserRole ? id : location.sharedUserGuid) : '';

  const memberGuid = sharedUser ? location.memberGuid : id;

  const searchMethod = sharedUser  ?
    searchFields => documentActions.searchSharedUserDocuments(searchFields) :
    searchFields => documentActions.searchDocuments(searchFields);

  return (<FileListWindow
    title={title}
    subtitle={subtitle}
    documentsByMember={typeof location.initialSection === 'undefined' ? false : location.documentsByMember}
    initialSection={typeof location.initialSection === 'undefined' ? 'All Sections' : location.initialSection}
    initialClassification={typeof location.initialClassification === 'undefined' ? 'All Media Types' : location.initialClassification}
    initialCategory={typeof location.initialCategory === 'undefined' ? 'All Categories' : location.initialCategory}
    initialFilename={typeof location.initialFilename === 'undefined' ? '' : location.initialFilename}
    initialAttributes={typeof location.initialAttributes === 'undefined' ? '' : location.initialAttributes}
    includeSectionFilter
    includeCompanyFilter={!isSharedUserVarSet}
    includeClassificationFilter
    includeCategoryFilter
    includeBeginDate
    initialBeginDate={isSharedUserVarSet ?
      location.startDate : (
        (typeof location.startDate !== 'undefined') ? location.startDate : new moment().subtract(90, 'days')
      )}
    includeEndDate
    initialEndDate={(typeof location.endDate !== 'undefined') ? location.endDate : new moment()}
    includeFilename
    includeAttribute
    viewer={DOCUMENT_VIEWER_MODES.LIST}
    userGuid={memberGuid}
    sharedUser={sharedUser}
    sharedUserGuid={sharedUserGuid}
    sharedUserRole={isSharedUserRole}
    getDocumentFromDocumentServiceMethod={getMethod}
    searchDocumentFromDocumentServiceMethod={searchMethod}
  />);
}

export default ListDocument;
